import { DayOfWeek, NotificationInterval } from "./elements/Enums";
import { TimeOfDay } from "./TimeOfDay";

export class Schedule {
  constructor(
    public scheduleID: number,
    public interval: NotificationInterval,
    public timeOfDay: TimeOfDay,
    public remindersAfterMinutes: number[],
    public dayOfWeek?: DayOfWeek,// Only for type === WEEKLY
    public dayOfMonth?: number,// Only for type === MONTHLY
    public expiresInSeconds?: number,
    public startDate?: Date,
    public endDate?: Date,
    public canUserEdit: boolean = false,
    public minTimeOfDay?: TimeOfDay,
    public maxTimeOfDay?: TimeOfDay,
    public diaryScheduleID?: number // Only for schedules of diary instances. scheduleID of corresponding schedule in the diary
  ) {
    // Ensure nested objects are actual instances of TimeOfDay
    this.timeOfDay = new TimeOfDay(timeOfDay.hour, timeOfDay.minute);
    if (minTimeOfDay) {
      this.minTimeOfDay = new TimeOfDay(minTimeOfDay.hour, minTimeOfDay.minute);
    }
    if (maxTimeOfDay) {
      this.maxTimeOfDay = new TimeOfDay(maxTimeOfDay.hour, maxTimeOfDay.minute);
    }

    // Disable editing if notification is expired
    if (this.endDate && this.endDate.getTime() <= Date.now()) {
      this.canUserEdit = false;
    }
  }

  public equals(other: Schedule): boolean {
    if (!(other instanceof Schedule)) {
      return false;
    }

    // Helper to compare optional fields of TimeOfDay objects
    const compareTime = (a?: TimeOfDay, b?: TimeOfDay) => {
      if (!a && !b) {
        return true; // Both are undefined/null
      }
      return a && b && a.equals(b); // Check if both exist and match
    };

    return (
      this.scheduleID === other.scheduleID &&
      this.interval === other.interval &&
      this.timeOfDay.equals(other.timeOfDay) &&
      this.dayOfWeek === other.dayOfWeek &&
      this.dayOfMonth === other.dayOfMonth &&
      this.expiresInSeconds === other.expiresInSeconds &&
      this.startDate?.getTime() === other.startDate?.getTime() &&
      this.endDate?.getTime() === other.endDate?.getTime() &&
      JSON.stringify(this.remindersAfterMinutes) === JSON.stringify(other.remindersAfterMinutes) &&
      this.canUserEdit === other.canUserEdit &&
      compareTime(this.minTimeOfDay, other.minTimeOfDay) &&
      compareTime(this.maxTimeOfDay, other.maxTimeOfDay) &&
      this.scheduleID === other.scheduleID
    );
  }

  /**
   * Creates and returns a clone of the Schedule
   */
  public clone(): Schedule {
    return new Schedule(
      this.scheduleID,
      this.interval,
      this.timeOfDay,
      [...this.remindersAfterMinutes],
      this.dayOfWeek,
      this.dayOfMonth,
      this.expiresInSeconds,
      this.startDate,
      this.endDate,
      this.canUserEdit,
      this.minTimeOfDay,
      this.maxTimeOfDay,
      this.scheduleID
    );
  }

  public get localISOTimeOfDay(): string {
    return this.timeOfDay.toLocalISOString();
  }

  public set localISOTimeOfDay(value: string) {
    if (value) {
      const date = new Date(value);
      this.timeOfDay.hour = date.getHours();
      this.timeOfDay.minute = date.getMinutes();
    }
  }
}
